import { render, staticRenderFns } from "./CustomerSwiper.vue?vue&type=template&id=2a3f609c&scoped=true&"
import script from "./CustomerSwiper.vue?vue&type=script&lang=ts&"
export * from "./CustomerSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerSwiper.vue?vue&type=style&index=0&id=2a3f609c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3f609c",
  null
  
)

export default component.exports